import { Component } from '@angular/core';
import { CmsParagraphComponent } from "@spartacus/core";
import { CmsComponentData } from "@spartacus/storefront";
import { Observable } from "rxjs";
import { filter } from "rxjs/operators";
import { AsyncPipe, NgIf } from "@angular/common";

@Component({
  selector: 'gen-footer-copyright-paragraph',
  imports: [
    AsyncPipe,
    NgIf
  ],
  templateUrl: './footer-copyright-paragraph.component.html',
})
export class GenFooterCopyrightParagraphComponent {
  constructor(
    protected cmsComponentData: CmsComponentData<CmsParagraphComponent>,
  ) {
  }

  protected get componentData$(): Observable<CmsParagraphComponent> {
    return this.cmsComponentData.data$.pipe(filter((data) => Boolean(data)));
  }
}
